import { RouteHttpVerb } from "@devowl-wp/utils";
export var locationRestConsentClearDelete = {
  path: "/consent/clear",
  method: RouteHttpVerb.DELETE
};